
export const userSuggestedQuestionsText = 
`List all points in csv format.
Draw all mag points.
How many points are in this file?
Are there any duplicate point numbers?
Summarize the contents of this file.
What were the closure errors on each of the setups?
What instruments were used in this survey?
Summarize all unique point descriptions.`;